import { render, staticRenderFns } from "./projects-attachments.vue?vue&type=template&id=4552a6b8&scoped=true&"
import script from "./projects-attachments.vue?vue&type=script&lang=js&"
export * from "./projects-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552a6b8",
  null
  
)

export default component.exports